<script>
import Base from "@/components/RequestDetails/FundData.vue";

export default {
  name: "DefaultViewFundData",
  extends: Base,
};
</script>

